"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOfferConfig = void 0;
var _culture = require("@ori/culture");
var _api = require("../../../api");
var _constants = require("../../../constants");
/** Hook that returns data in relation to campaign offer, offer validity and points. */
const useOfferConfig = ({
  offerId,
  offerType,
  validTo
}) => {
  const currentDate = new Date();
  const isCampaignOffer = offerType === _constants.CAMPAIGN_OFFER_TYPE;
  const data = (0, _api.useGetCampaignPoints)({
    isCampaignOffer,
    offerId
  });
  // Handle expiring points and days until expiration
  const pointsExpiration = data?.expiration ?? new Date();
  const expiringPoints = data?.expiringPoints ?? 0;
  const pointsExpirationTime = pointsExpiration.getTime() - currentDate.getTime();
  const pointsExpirationDays = Math.ceil(pointsExpirationTime / (1000 * 3600 * 24));
  // Handle and format offer validity
  const offerVisibilityLimit = new Date();
  offerVisibilityLimit.setDate(offerVisibilityLimit.getDate() + _constants.OFFER_VALIDITY_VISIBILITY_LIMIT);
  const offerValidityDate = new Date(validTo ?? '');
  const isValidityVisible = Boolean(validTo && offerValidityDate < offerVisibilityLimit);
  const offerValidity = (0, _culture.useFormatDate)(offerValidityDate, _culture.DateFormat.MonthDay, {
    toLocalTimezone: true
  });
  return {
    expiringPoints,
    isCampaignOffer,
    isValidityVisible,
    offerValidity,
    pointsExpirationDays
  };
};
exports.useOfferConfig = useOfferConfig;